// extracted by mini-css-extract-plugin
module.exports = {"ui_input":"Input_ui_input__3uzYM","ui_input_material":"Input_ui_input_material__2bn_Q","label":"Input_label__2owTN"};